import Modal from "../Modal";
import UserUsernameNewForm from "../../forms/user/UserUsernameNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function UserUsernameNewModal({show, handleClose, callback, person_id, title}) {
    const { t } = useTranslation();
    return (
        <Modal title={title} show={show} handleClose={handleClose} width="400px">
            <UserUsernameNewForm handleClose={handleClose} callback={callback} person_id={person_id} />
        </Modal>
    );
};